import { useIntl } from '@capsicum/common';

export const useExportAndCloseAccountErrorDrawer = () => {
	const { $t } = useIntl();

	return {
		intlTexts: {
			closeButton: $t('global.button.close'),
			errorDescription: $t('error.defaultDescription'),
			errorTitle: $t('error.default')
		}
	};
};
